import React from "react";

const Advanced = () => {
    return <div>Advanced</div>;
};

export default Advanced;
